import Home from '../features/landings/assets/Home';
import LandingInvoicesImage from '../features/landings/assets/LandingInvoicesImage';
import Background from '../features/landings/assets/Background';
import MobileBackground from '../features/landings/assets/MobileBackground';
import FingoLogo from '../features/landings/assets/FingoLogo';
import WomanImage from '../features/landings/assets/simulator-register/WomanImage';

const LOGO_BASE = 'https://d27snhiba7p64h.cloudfront.net/images/logos/fingo-logo.webp';
const MEDIA_DESKTOP = '(min-width: 768px)';
const MEDIA_MOBILE = '(max-width: 767px)';

const withMedia = (href, media) => ({ href, media });

const ROUTE_IMAGE_PRELOADS = [
  {
    paths: ['/'],
    images: [Home],
  },
  {
    paths: ['/user-register', '/user-login'],
    images: [LandingInvoicesImage],
  },
  {
    paths: ['/simulator-register-video'],
    images: [WomanImage],
  },
  {
    paths: ['/promo-operation'],
    images: [
      Background,
      withMedia(MobileBackground, MEDIA_MOBILE),
      FingoLogo,
      `${LOGO_BASE}?width=170&format=avif`,
      withMedia(`${LOGO_BASE}?width=120&format=avif&quality=100`, MEDIA_DESKTOP),
      withMedia(`${LOGO_BASE}?width=90&format=avif&quality=100`, MEDIA_MOBILE),
    ],
  },
];

export default ROUTE_IMAGE_PRELOADS;
